import { PublicClientApplication, LogLevel } from "@azure/msal-browser";

// Strip control characters (0x00-0x1f, 0x7f) from URLs to prevent path manipulation (CWE-22)
// eslint-disable-next-line no-control-regex
const controlCharsRegex = /[\x00-\x1f\x7f]/g;
const sanitizeRedirectUri = (url) => {
  const cleaned = url.replace(controlCharsRegex, '');
  // Only allow same-origin redirects (prevent open redirect via crafted URLs)
  try {
    const parsed = new URL(cleaned);
    return parsed.origin + parsed.pathname + parsed.search + parsed.hash;
  } catch {
    return '/';
  }
};

export const msalConfig = {
  auth: {
    clientId: "5705887f-cb96-4765-8239-57fa17f8a5d0",
    authority: "https://login.microsoftonline.com/12a3af23-a769-4654-847f-958f3d479f4a",
    redirectUri: sanitizeRedirectUri(window.location.href),

  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Info:
            console.info(message);
            break;
          case LogLevel.Verbose:
            console.debug(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
          default:
            // No action needed for other log levels
            break;
        }
      }
    }
  }
};

export const loginRequest = {
  scopes: ["User.Read"],
  popupWindowAttributes: "width=600,height=600,left=100,top=100" // Ensures popup window
};

export const msalInstance = new PublicClientApplication(msalConfig);
await msalInstance.initialize();